var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"three-line":""}},[_c('v-list-item-group',[_c('v-subheader',[_vm._v("最近の提出")]),_vm._l((_vm.currentItems),function(item){return [_c('RecentResultListItem',{key:item.id,attrs:{"code":item}})]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }